import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import type { FC } from "react";
import { useTranslation } from "react-i18next";

export const DeleteButtonDialog: FC<{
  open: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}> = ({ open, onCancel, onConfirm }) => {
  const { t } = useTranslation();

  return (
    <Dialog open={open}>
      <DialogTitle>Delete buttons</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {t(`Are you sure you wish to delete the button(s)?`)}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button data-analytics-id="lexical-delete-button-confirm-dialog-cancel" onClick={onCancel}>
          Cancel
        </Button>
        <Button
          data-analytics-id="lexical-delete-button-confirm-dialog-confirm"
          variant="contained"
          onClick={onConfirm}
        >
          Yes, I’m sure
        </Button>
      </DialogActions>
    </Dialog>
  );
};
